export default [
    {
        path: '/colors',
        name: 'colors',
        meta: {
            layout: 'dashboard'
        },
        component: () => import('VIEWS/Catalogs/Colors.vue')
    }
]